import type { Input } from '@builder.io/sdk';

const conversionPanelField = [
  {
    name: 'body',
    type: 'richText',
  },
  {
    name: 'button',
    type: 'object',
    subFields: [
      {
        name: 'label',
        type: 'string',
      },
      {
        name: 'url',
        type: 'string',
      },
      {
        name: 'textStyle',
        type: 'string',
        enum: ['upper', 'standard'],
        defaultValue: 'standard',
      },
      {
        name: 'color',
        type: 'string',
        enum: ['gray', 'whitePrimary', 'teal', 'grayBlue', 'lightGray'],
        defaultValue: 'gray',
      },
    ],
  },
  {
    name: 'backgroundColor',
    type: 'string',
    enum: ['blue', 'gray', 'teal', 'white', 'lightgray', 'ash', 'darkash', 'carbon', 'wgray80', 'greige'],
    defaultValue: 'white',
  },
] as const satisfies DeepReadonly<Input[]>;

const conversionPanelConfig = {
  name: 'Conversion Panel',
  inputs: conversionPanelField,
};

export type ConversionPanelProps = GenerateBuilder<typeof conversionPanelField>;

export default conversionPanelConfig;
